import React, { Component } from 'react';
import classNames from 'classnames';

import './dpit-target-indicator.scss';


export default class TargetIndicator extends Component {
	constructor(props) {
		super(props);
		this.modifyChildren = this.modifyChildren.bind(this);
	}

	modifyChildren(child) {
		const classes = classNames({
			[child.props.className]: child.props.className,
			[this.props.classBEMRoot + '__icon']: true
		});

		return React.cloneElement(child, { className: classes });
	}

	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			[this.props.classBEMRoot + '--no-target']: this.props.inactive,
			[this.props.classBEMRoot + '--skipped']: this.props.skip === '1',
			[this.props.classBEMRoot + '--clickable']: this.props.onClick,
			[this.props.classBEMRoot + '--small']: this.props.small,
			[this.props.classBEMRoot + '--scale-on-hover']: this.props.scaleOnHover,

		});

		return (
			<div className={mainClasses} title={this.props.title} onClick={this.props.onClick}>
				{React.Children.map(this.props.children, (child) => this.modifyChildren(child))}
			</div>
		);
	}
}
